import { Button } from "@dune/ui";
import { useDocumentStore } from "../../../stores/document.store";

type PreviewFileLinkProps = {
	file: {
		id: string;
		name: string;
	};
};

export const PreviewFileLink = ({ file }: PreviewFileLinkProps) => {
	const selectDocument = useDocumentStore((state) => state.selectDocument);
	return (
		<Button
			variant="link"
			className="p-0 py-1 h-auto font-normal text-primary text-left justify-start truncate max-w-full"
			onClick={() => selectDocument("", file.id, "", file.name)}
		>
			<span className="truncate max-w-full" title={file.name}>
				{file.name}
			</span>
		</Button>
	);
};
